import { styled } from '@mui/material/styles';
import { Box, MenuItem, Select } from '@mui/material';
import { CSSProperties } from 'react';

export const StyTooltipMenuItem = styled(MenuItem, {
    name: 'StyTooltipMenuItem',
})({
    fontSize: '12px',
    padding: '0',
    maxWidth: '100px',
    overflow: 'hidden',
});

export const StyStatusSelect = styled(Select, {
    name: 'StyStatusSelect',
    shouldForwardProp: (prop) => !['selectedColor', 'canEdit'].includes(prop),
})<{ selectedColor: string; canEdit: boolean }>(
    ({ selectedColor, canEdit }) => ({
        '& .MuiSelect-select': {
            color: selectedColor,
            borderColor: selectedColor,
            backgroundColor: `${selectedColor}0f`,
            border: 'solid 1px',
            paddingTop: '2px',
            paddingBottom: '2px',
            maxWidth: '100px',
            ...(!canEdit
                ? {
                      '& .MuiSvgIcon-root': {
                          visibility: 'hidden',
                          width: 0,
                      },
                      '& .MuiSelect-root': {
                          paddingRight: '14px',
                      },
                  }
                : {}),
        },
    }),
);

export const StyStatus = styled(Box, {
    name: 'StyStatus',
    shouldForwardProp: (prop) => prop !== 'color',
})<{ color: CSSProperties['color'] }>(({ color }) => ({
    lineHeight: '36px',
    '&&& fieldset': {
        borderColor: color,
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    '& svg.MuiSelect-icon': {
        color,
    },
}));
